export default {
    baseStyle: {
        shopthelookTile: {
            position: 'relative'
        },
        shopthelookTileLink: {
            display: 'block'
        },
        shopthelookTileImg: {
            width: '100%'
        },
        shopthelookTileOverlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            w: '100%',
            h: '100%',
            bg: 'rgba(0,0,0,0.6)',
            color: 'white',
            opacity: '0',
            transition: 'opacity 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 4,
            textAlign: 'center'
        },
        shopthelookTileText: {
            noOfLines: 1,
            color: 'white',
            fontWeight: 'black',
            fontSize: '26.72px',
            mb: '4',
            lineHeight: '10'
        },
        shopthelookTilePrize: {
            color: 'white',
            mb: '4',
            fontSize: '26.36px'
        }
    }
}
